import React, { Fragment, useState } from 'react'
import { Table, Modal, Card, Button } from 'react-bootstrap'
import { formato_monto } from '../../common/Formatos';
import { FaSearch } from "react-icons/fa";


const CustomTable = ({ data, handleInforme, movimiento }) => {
    
    const [tituloModal, setTituloModal] = useState('');
    const [comentario, setComentario] = useState('Sin comentarios.');
    const [comentarioVisado, setComentarioVisado] = useState('Sin comentarios.');
    const [showModal, setShowModal] = useState(false);

    return (
        <Fragment>
            <Table striped className="customTable">
                <thead>
                    <tr>
                        <th style={{ textAlign: 'center' }}>Implicado</th>
                        <th style={{ textAlign: 'center' }}>RC Daño Emergente</th>
                        <th style={{ textAlign: 'center' }}>RC Lucro Constante</th>
                        <th style={{ textAlign: 'center' }}>RC Daño Moral</th>
                        <th style={{ textAlign: 'center' }}>RC Asto. Pasajero</th>
                        <th style={{ textAlign: 'center' }}>Total Implicado</th>
                        <th style={{ textAlign: 'center' }}>Estado</th>
                        <th style={{ textAlign: 'center' }}>Fecha Ult. Registro</th>
                        <th style={{ textAlign: 'center' }}>Usr. Registro</th>
                        <th style={{ textAlign: 'center' }}></th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((d, index) => (
                        <tr key={index}>
                            <td>{d?.nombreImplicado}</td>
                            <td style={{ textAlign: 'center' }}>{formato_monto(d?.monto_rcde)}</td>
                            <td style={{ textAlign: 'center' }}>{formato_monto(d?.monto_rclc)}</td>
                            <td style={{ textAlign: 'center' }}>{formato_monto(d?.monto_rcdm)}</td>
                            <td style={{ textAlign: 'center' }}>{formato_monto(d?.monto_rcap)}</td>
                            <td style={{ textAlign: 'center' }}>{formato_monto(d?.total)}</td>
                            <td style={{ textAlign: 'center' }}>{d?.estado}</td>
                            <td style={{ textAlign: 'center' }}>
                                <a href='#' style={{textDecoration:''}} 
                                    onClick={(e)=>{
                                        e.preventDefault()
                                        setComentario(d?.comentario ? d?.comentario : '<Sin Observaciones>');
                                        setComentarioVisado(d?.comentarioVisado ? d?.comentarioVisado : '<Sin Observaciones>');
                                        setTituloModal(movimiento + " " + d?.nombreImplicado)
                                        setShowModal(true);
                                        //alert(d?.comenta rio)
                                    }}
                                >{d?.ultFechaRegistro}
                                </a>
                            </td>
                            <td style={{ textAlign: 'center' }}>{d?.usuario}</td>
                            <td>
                                {data?.length - 1 !== index &&
                                    <FaSearch
                                        color='gray'
                                        size={20}
                                        title={d.idfolioCargaDocto ? "Ver Documento" : "No existe Documento"}
                                        style={{ cursor: d.idfolioCargaDocto ? 'pointer' : 'not-allowed' }}
                                        onClick={() => handleInforme(d)}
                                    />
                                }
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
            {data?.length === 0 &&
                <span style={{ display: 'inherit', textAlign: 'center' }}>No hay registros encontrados.</span>
            }
            <Modal show={showModal} onHide={() => setShowModal(false)} size='md'>
                <Card>
                    <Card.Header className='mt-0 mb-0' as='h6' style={{ backgroundColor: '#e8761a', color: 'white' }}>
                        Observaciones - {tituloModal}
                    </Card.Header>
                    <Card.Body>
                        <h5 className="card-title">Responsable Gestión:</h5>
                        {comentario}
                        <br/><br/>
                        <h5 className="card-title">Analista Compañía:</h5>
                        {comentarioVisado}
                    </Card.Body>
                    <Card.Footer style={{ display: 'flex', justifyContent: 'center' }}>
                        <Button className='m-2 w-auto' variant='outline-info' onClick={() => setShowModal(false)}>Cerrar</Button>
                    </Card.Footer>
                </Card>
            </Modal>
            <style type='text/css'>
                {`
                        .customTable > thead {
                            color: white; 
                            background-color: rgb(114, 139, 176);
                            font-size: 14px
                        }
                        .customTable > thead > tr > th {
                            padding: 20px 0;
                            font-size: 16px;
                            font-weight: 500;
                        }
                    `}
            </style>
        </Fragment>
    )
}

export default CustomTable